var Fields = {
  // General
  cwid: "CWID",
  password: "Password",
  old_password: "Old Password",
  status: "Status",
  IPIN: "IPIN",
  other_wl_city: "Other",
  other_poh_city: "Other",
  mrf_id: "Request For",
  employeeno: "Employee Name",
  confidential: "Confidential",
  manulife_withdrawal: "Manulife Withdrawal",
  exit_interview: "Exit Interview",
  clearance: "Clearance",
  gender: "Gender",
  pob: "Place of birth",
  dob: "Date of birth",
  ktp: "KTP No",
  npwp: "NPWP No",
  address: "Address",
  province: "Province",
  postal_code: "Postal Code",
  home_phone: "Home Phone",
  cell_phone: "Cell Phone",
  marital_status: "Marriage Status",
  salary: "Salary",
  position: "Position Title",
  manager: "Admin Manager",
  costcenter: "Cost Center",
  baymap: "Baymap",
  encryption_key: "Encryption Key",
  startdate: "Start Date",
  enddate: "End Date",
  receiver_email: "Receiver Email",
  email: "Email",
  ccemail: "CC Email",
  lock: "Lock Status",
  have_outstanding: "Have outstanding?",
  employee_update: "Import Employee",
  employee_status: "Employee Status",
  msg_id : "Department",
  supervisor: "Superior",
  superior: "Superior",
  // AccessEmployee
  ae_cwid: "CWID",
  ae_al_id: "Access Level",
  access_level: "Access Level",
  // employee_status: "Status",
  ae_status: "Status",
  typeOf: "Type",
  default_password: 'Default Password',
  // Employee
  employeename: "Employee Name",
  // AcessLevel
  al_name: "Level Name",
  al_access_menu: "Access Menu",
  al_access_module: "Access Module",
  // MrDivision
  md_code: "Code",
  md_name: "Division",
  // MrBussinessGroup
  mbg_country_id: "Country ID",
  mbg_bussiness_group: "Bussiness Group",
  // MrSubGroup
  msg_name: "Department",
  msg_dph: "Department Head",
  msg_hrbp: "HRBP",
  msg_bg_id: "Division",
  msg_status: "Status",
  msg_is_operation: "Is Operation?",
  msg_manager: "Manager",
  // MrGrade
  mg_grade: "Grade",
  // MrPayscaleArea
  mpa_name: "Payscale Area",
  // MrWorkLocation
  mwl_code: "Code",
  mwl_name: "Work Location",
  mwl_province: "Province",
  mwl_city: "City",
  // MrPostalArea
  mpa_provinsi: "Provinsi",
  mpa_kabupaten: "Kota/Kab",
  mpa_kecamatan: "Kecamatan",
  mpa_kelurahan: "Kelurahan",
  mpa_kodepos: "Kode Pos",
  mpa_area: "Area",
  // MrFacilitySetup
  mwf_name: "Working Facility",
  mfs_mwf_id: "Working Facility",
  mfs_heading: "Heading",
  mfs_group: "Group",
  mfs_type: "Type",
  mfs_is_lend: "Is Lend Facility?",
  mfs_with_remarks: "With Remarks",
  mfs_name: "Facility Name",
  mfs_values: "Facility Data",
  mfs_default: "Default Value",
  mfs_status: "Status",
  // MrTemplate
  mt_slug: "Slug",
  mt_title: "Template Title",
  mt_template: "Template Body",
  // MrCostCenter
  mcc_msg_id: "Department",
  mcc_mjt_id: "Position Title",
  mcc_name: "Cost Center Name",
  mcc_costcenter: "Cost Center",
  mcc_cwid: "Owner",
  mcc_admin: "Admin",
  mcc_cdh: "CDH",
  // MrAccessDoor
  mad_name: "Access Door",
  // MrJobTitle
  mjt_name: "Position Title",
  mjt_code: "Position Title Code",
  mjt_access_level: "Access Level",
  position_id: "Position Title",
  mjt_id: "Position Title",
  // MrJobTitle
  s_name: "Name",
  s_note: "Notes",
  s_slug: "Slug",
  s_values: "Values",
  s_type: "Type",
  // AppInitiation
  ai_request_number : "Request No",
  ai_mrf_id : "Request For",
  ai_employeeno : "Employee Name",
  ai_cwid_from : "Employee Name",
  ai_cwid : "Employee Name",
  ai_employee_id : "Employee Name",
  ai_ipin : "IPIN",
  ai_bg_id : "Division",
  ai_mjt_id: "Position Title",
  ai_msg_id : "Department",
  ai_cc_id : "Cost Center SAP",
  ai_superior: "Superior",
  ai_employee_name : "Employee Name",
  ai_mwl_id : "Work Location",
  ai_wl_province : "Province",
  ai_wl_city : "City",
  ai_request_date : "Request Date",
  ai_relocation_allowance : "Relocation Allowance",
  ai_relocation_area : "Relocation Area",
  ai_position : "Position Title",
  ai_new_title : "New Title",
  ai_mws_id : "Employee Type",
  ai_number_position : "Number of Position",
  ai_confidential_status : "Confidential Status",
  ai_hiring_manager : "Hiring Manager",
  ai_primary_interviewer : "Primary Interviewer/Assessor",
  ai_additional_interviewers : "Additional Interviewer",
  ai_shift_rotation : "Shift Rotation",
  ai_direct_report_manager : "Admin Manager",
  ai_previous_salary : "Previous Monthly Salary (Rp)",
  ai_previous_midpoint_salary : "Previous Mid Point Proposed Monthly Salary (Rp)",
  ai_previous_salary_comparatio : "Previous Salary Comparatio (%)",
  ai_proposed_salary : "Proposed Monthly Salary (Rp)",
  ai_midpoint_salary : "Mid Point Proposed Monthly Salary (Rp)",
  ai_salary_comparatio : "Salary Comparatio (%)",
  ai_desire_date : "Desire Start Date",
  ai_effective_date : "Effective Date of Commencement",
  ai_date_of_hire : "Date of Hire",
  ai_end_contract_date : "End Date of Contract",
  ai_effective_end_date : "Effective Date of Commencement",
  ai_end_date : "Last Date of Work",
  ai_end_fathering_period : "End of Grand Fathering Period",
  ai_relocation_date : "Relocation Date",
  ai_relocation_support_date : "Relocation Support Date",
  ai_relocation_period : "Relocation Period",
  ai_preferred_candidate : "Referral Candidate",
  ai_major_tasks : "Major Tasks & responsibility",
  ai_qualifications : "Qualifications",
  ai_notes : "Notes",
  ai_remarks : "Remarks",
  ai_file : "Document",
  ai_encrypt_key : "Encryption Key",
  ai_effective_join_date: "Effective Join Date",
  // AppRecruitmentInit
  arr_interview_date: "Date of Interview",
  arr_technical_skills: "Functional/ Technical Skills",
  arr_competency: "Competency",
  arr_others: "Other",
  arr_potential_for_future: "Potential for Future Roles",
  arr_decision: "Decision",
  arr_mcu_status: "MCU Status",
  arr_mcu_file: "MCU File",
  arr_offering_status: "Status",
  arr_offering_remarks: "Remarks",
  arr_personal_data_file: "Personal Data",
  functionName : "Function Name",
  description : "Description",
  date: "Date",

  // MrGAForm
  ga_form_name: "Form Name",
  ga_form_link: "Form Link",

  // MrFormChecklist
  mfc_name: "Form Checklist Name",
  mfc_title: "Form Checklist Title",
  mfc_desc: "Form Checklist Description (ID)",
  mfc_desc_en: "Form Checklist Description (EN)"
}

export default Fields